import { render } from "./ClinicalDetails.vue?vue&type=template&id=0e2809a1"
import script from "./ClinicalDetails.vue?vue&type=script&lang=js"
export * from "./ClinicalDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__